module.exports = __webpack_public_path__ + "static/media/atendimento-banner.55c09a77.jpg";